import { connect } from "react-redux";
import { TableAction } from "../components/TableAction";
import { actionConfirmation } from "../actions/actions";
import { doExecuteAction } from "../actions/thunks";
function mapStateToProps({}, {}) {
    return {};
}
function mapDispatchToProps(dispatch) {
    return {
        onHandleAction: (id, datum, keyField, action, itemValue) => {
            if (action.confirmation) {
                dispatch(actionConfirmation(id, datum, keyField, action));
                return Promise.resolve();
            }
            else {
                return dispatch(doExecuteAction(id, datum, keyField, action, itemValue));
            }
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TableAction);
